import { api, getList } from "./api";
import type { Entrepot } from "../types/entrepot";
import type { EntrepotPayload } from "../types/entrepot";

// Récupérer tous les entrepôts
export async function getAllEntrepots(): Promise<Entrepot[]> {
  return getList<Entrepot>("/entrepots/");
}

// Créer un entrepôt
export async function createEntrepot(entrepot: EntrepotPayload) {
  const { data } = await api.post("/entrepots/", entrepot);
  return data;
}

// Mettre à jour un entrepôt
export async function updateEntrepot(id: string, entrepot: EntrepotPayload) {
  const { data } = await api.put(`/entrepots/${id}/`, entrepot);
  return data;
}

// Supprimer un entrepôt
export async function deleteEntrepot(id: string) {
  await api.delete(`/entrepots/${id}/`);
}
